module.exports = __webpack_public_path__ + "static/incard4-4a8ec1347071a7b56de49d409dc33a4f.png";